import { PrebidModuleDTO } from 'features/globalSetup/api/types/prebidModule'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const PREBID_MODULE_PARAMETERS: TypedDocumentNode<PrebidModuleDTO> = gql`
  fragment PrebidModuleParameter on PrebidModuleParamsSchema {
    label
    name
    required
    tooltip
    type
  }
`
